import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import React, { ReactElement } from "react";
import Button, { ButtonAppearance } from "../Button/Button";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string | ReactElement;
  confirmText: string;
  cancelText: string;
  confirmButtonAppearance?: ButtonAppearance;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    open,
    title,
    description,
    confirmText,
    cancelText,
    confirmButtonAppearance,
    onClose,
    onConfirm,
  } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="dui-confirm-dialog"
      PaperProps={{ className: "dui-confirm-dialog-paper" }}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <div className="dui-confirm-dialog-content">{description}</div>
      <DialogActions>
        <Button onClick={onConfirm} appearance={confirmButtonAppearance}>
          {confirmText}
        </Button>
        <Button onClick={onClose} type="text">
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
